// API请求配置



function generateDeviceId() {
  const { v4: uuidv4 } = require('uuid');
  return uuidv4().replace(/-/g, '');
}

// 获取或生成设备ID
function getDeviceId() {
  let deviceId = localStorage.getItem('deviceId');
  if (!deviceId) {
    deviceId = generateDeviceId();
    localStorage.setItem('deviceId', deviceId);
  }
  return deviceId;
}

export const API_CONFIG = {
  // 开发环境使用代理，生产环境使用环境变量配置的 API 地址
  BASE_URL: process.env.NODE_ENV === 'development' 
    ? '/api'  // 使用代理路径
    : (process.env.API_BASE_URL || 'http://events.enjoy.ai/'),
  TIMEOUT: 10000,
  MAX_RETRIES: 0, // 不重试
  RETRY_DELAY: 1000, // 重试延迟
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Platform': 'web',
    'Device-Type': 'web',
    'Device-Version': '1.0.0',
    'Device-Id': getDeviceId(),
    "Registration-Channel": "enjoy_vote",
    "Registration-Version": "1.0.0"
  },
  withCredentials: false,
  crossDomain: true,
};

// API错误码配置
export const ERROR_CODE = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
}; 

